import { render, staticRenderFns } from "./OrderConfigurationModal.vue?vue&type=template&id=5df54133&scoped=true"
import script from "./OrderConfigurationModal.vue?vue&type=script&lang=js"
export * from "./OrderConfigurationModal.vue?vue&type=script&lang=js"
import style0 from "./OrderConfigurationModal.vue?vue&type=style&index=0&id=5df54133&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5df54133",
  null
  
)

export default component.exports